import manuscriptInfo from './manuscriptInfo';

export default manuscriptInfo;
